import MuiStack, { type StackProps as MuiStackProps } from '@mui/material/Stack';

type StackGap = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type StackAlign = 'start' | 'center' | 'end' | 'stretch';
type StackJustify = 'start' | 'center' | 'between' | 'end';

type StackProps = Omit<MuiStackProps, 'gap' | 'alignItems' | 'justifyContent'> & {
  gap?: StackGap;
  align?: StackAlign;
  justify?: StackJustify;
};

const gapScale: Record<StackGap, number> = {
  xs: 0.5,
  sm: 1,
  md: 1.5,
  lg: 2,
  xl: 3,
};

const alignScale: Record<StackAlign, MuiStackProps['alignItems']> = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  stretch: 'stretch',
};

const justifyScale: Record<StackJustify, MuiStackProps['justifyContent']> = {
  start: 'flex-start',
  center: 'center',
  between: 'space-between',
  end: 'flex-end',
};

export const Stack = ({
  direction = 'column',
  gap = 'md',
  align = 'stretch',
  justify = 'start',
  ...props
}: StackProps): JSX.Element => {
  return (
    <MuiStack
      direction={direction}
      gap={gapScale[gap]}
      alignItems={alignScale[align]}
      justifyContent={justifyScale[justify]}
      {...props}
    />
  );
};
